import React, { Component } from 'react';

import style from './PrintHeader.module.scss';

interface Props {
  title?: string | JSX.Element;
  description?: string | JSX.Element;
}

class PrintHeader extends Component<Props> {
  render() {
    const { title, description } = this.props;

    return (
      <div className={style.header}>
        <div className={style.logo}>
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="logo" />
        </div>
        <div className={style.text}>
          {!!title && <div className={style.title}>{title}</div>}
          {!!description && (
            <div className={style.description}>{description}</div>
          )}
        </div>
      </div>
    );
  }
}

export default PrintHeader;
